__turbopack_context__.v({
  "blink": "ButtonLoader-module__nqlnIG__blink",
  "loader": "ButtonLoader-module__nqlnIG__loader",
});
